'use strict';

export default angular
  .module('maestro.directives.common.bg-image', [])

  .directive('bgImage', function() {
    return function(scope, element, attr) {

      attr.$observe('bgImage', function() {

        let defaultImage = attr.fallbackBgImage;

        if (!attr.bgImage) {
          element.css('background-image', 'unset');
        } else {
          let image = new Image();
          image.src = attr.bgImage;
          image.onload = function() {
            // Image loaded, set the background image to it
            element.css('background-image', 'url(' + attr.bgImage + ')');
          };
          image.onerror = function() {
            // Image failed to load - use default
            if (!defaultImage) {
              element.css('background-image', 'unset');
            } else {
              element.css('background-image', 'url(' + defaultImage + ')');
            }
          };
        }
      });
    };
  })

  .name;
